import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridItem from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import Check from "@insite/mobius/Icons/Check";
import Img from "@insite/mobius/Img";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
// import ToasterContext from "@tCentro/MobiusOverrides/Toast/ToasterContext";

import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import AlertMessageIcon from "@tCentro/Icons/AlertMessageIcon";
import CustomAlertIcon from "@tCentro/Icons/CustomAlertIcon";
import CustomInfoIcon from "@tCentro/Icons/CustomInfoIcon";
import RightArrowIcon from "@tCentro/Icons/RightArrowIcon";
import CustomApplicationState from "@tCentro/Store/CustomApplicationState";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import * as React from "react";
import { useContext } from "react";
import { useEffect, useRef } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    isQtyAdjusted: boolean;
    multipleProducts: boolean;
    cartLines: CartLineModel[] | null;
    brandName?: string;
    toasterDisplayVal: any;
    onToastDismiss?: () => void;
}
type PromoDetail = {
    description: string;
    startDate?: string;
    endDate?: string;
};

export interface ProductAddedToCartMessageStyles {
    productNum?: TypographyPresentationProps;
    mpnNumber?: TypographyPresentationProps;
    productPrice?: TypographyPresentationProps;
    productTotal?: TypographyPresentationProps;
    cartTotal?: TypographyPresentationProps;
    sectionName?: TypographyPresentationProps;
    optionName?: TypographyPresentationProps;
    configHeading?: TypographyPresentationProps;
    messageWrapper?: InjectableCss;
    productPriceWrapper?: InjectableCss;
    qtyRow?: InjectableCss;
    productListWrapper?: InjectableCss;
    configSectionWrapper?: InjectableCss;
    productWrapper?: InjectableCss;
    productImageDetailsWrapper?: InjectableCss;
    productImageWrap?: InjectableCss;
    defaultText?: TypographyPresentationProps;
    quantityAdjustedText?: TypographyPresentationProps;
    headerText?: TypographyPresentationProps;
    imgStyle?: LazyImageProps;
    routerLink?: LinkPresentationProps;
    iconTextWrapper?: InjectableCss;
    iconStyle?: InjectableCss;
    orderMinStyles?: InjectableCss;
    orderMinMsgStyles?: InjectableCss;
    viewCartBtnStyles?: InjectableCss;
    continueBtnStyles?: InjectableCss;
    btnContainerStyles?: InjectableCss;
    requireDrawingApproval?: InjectableCss;
    requireDrawingApprovalWrapper?: InjectableCss;
    drawwingApprovalIcon?: IconPresentationProps;
    promoMsgModalWrapper?: InjectableCss;
    promoMsgLinePartOne?: InjectableCss;
    promoMsgLinePartTwo?: InjectableCss;
    promoMsgWrapper?: InjectableCss;
    promoRightTickIcon?: IconPresentationProps;
    promoMsgLineTwo?: InjectableCss;
}

export const productAddedToCartMessageStyles: ProductAddedToCartMessageStyles = {
    promoMsgLineTwo: {
        css: css`
            font-weight: 400;
            font-family: Poppins;
            font-size: 12px;
            line-height: 16px;
            color: #636161;
        `,
    },
    promoRightTickIcon: {
        css: css`
            width: 20px;
            height: 20px;
            color: #266b40;
            svg {
                width: 20px;
                height: 20px;
            }
        `,
    },
    promoMsgWrapper: {
        css: css`
            display: flex;
            gap: 4px;
        `,
    },
    promoMsgModalWrapper: {
        css: css`
            margin: 24px 0 8px;
            padding: 8px 16px;
            background: #eef3f0;
        `,
    },
    promoMsgLinePartOne: {
        css: css`
            font-size: 14px;
            font-weight: 600;
            line-height: 20px;
            color: ${getColor("primary")};
        `,
    },
    promoMsgLinePartTwo: {
        css: css`
            font-size: 13px;
            font-weight: 500;
            margin-top: 4px;
        `,
    },
    btnContainerStyles: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            align-items: center;
            justify-content: center;
            gap: 20px;
        `,
    },
    viewCartBtnStyles: {
        // variant: "primary",
        css: css`
            background-color: ${getColor("secondary")} !important;
            border-radius: 24px !important;
            min-height: unset !important;
            width: 100%;
            padding: 10px !important;
            justify-content: center;
            > span {
                font-size: 18px;
                font-style: normal;
                font-weight: 600;
                line-height: 24px;
                color: ${getColor("secondary.contrast")} !important;
            }
        `,
    },
    continueBtnStyles: {
        css: css`
            background-color: white !important;
            border: 2px solid ${getColor("secondary")} !important;
            border-radius: 24px !important;
            min-height: unset !important;
            width: 100%;
            padding: 10px !important;
            justify-content: center;

            > span {
                font-size: 18px;
                color: ${getColor("secondary")} !important;
                font-style: normal;
                font-weight: 600;
                line-height: 24px;
            }
        `,
    },
    orderMinStyles: {
        css: css`
            display: flex;
            flex-direction: row;
            background-color: #faeecf;
            padding: 16px;
            border-left: 4px solid #e8aa0f;
            margin-bottom: 24px;
        `,
    },
    orderMinMsgStyles: {
        css: css`
            font-size: 12px;
            font-style: normal;
            font-weight: 600;
            line-height: 16px;
        `,
    },
    iconTextWrapper: {
        css: css`
            display: flex;
            align-items: baseline;
            margin-bottom: 17px;
            margin-top: 0px !important;
        `,
    },
    iconStyle: {
        css: css`
            height: 22.5px;
            width: 31.5px;
            svg {
                height: 22.5px;
                width: 31.5px;
                color: ${getColor("success")};
                > path {
                    fill: ${getColor("success")};
                }
            }
        `,
    },
    headerText: {
        variant: "h2",
        css: css`
            margin-left: 13px !important;
            color: ${COLORS.text.base};
            margin-top: 0px !important;
        `,
    },
    productNum: {
        variant: "p",
        css: css`
            margin-bottom: 8px;
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            font-size: ${TYPOGRAPHY.size.smaller} !important;
            line-height: 16px;
            color: ${getProp("theme.typography.p.color")};
        `,
    },
    mpnNumber: {
        css: css`
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.smaller};
            line-height: 20px;
            color: ${getProp("theme.typography.p.color")};
            margin-bottom: 12px;
        `,
    },
    productPrice: {
        variant: "p",
        css: css`
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.smaller};
            line-height: 20px;
            color: ${getProp("theme.typography.p.color")};
        `,
    },
    productTotal: {
        variant: "p",
        css: css`
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.smaller} !important;
            line-height: 20px;
            color: ${getProp("theme.typography.p.color")};
        `,
    },
    cartTotal: {
        variant: "h4",
        css: css`
            color: ${getProp("theme.typography.h4.color")};
            text-align: center;
            margin-top: 24px !important;
            margin-bottom: 15px !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        font-size: ${TYPOGRAPHY.size.large};
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    productWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    productImageWrap: {
        css: css`
            flex-basis: 30%;
            div {
                width: 97.5px;
                height: 97.5px;
                background: ${COLORS.white};
                box-shadow:
                    0px 0px 1px rgba(38, 37, 37, 0.56),
                    0px 2px 8px rgba(38, 37, 37, 0.16);
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 40%;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    productPriceWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            flex-basis: 70% !important;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 60% !important;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
        `,
    },
    productListWrapper: {
        css: css`
            max-height: min-content;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        max-height: min-content;
                    `,
                    null,
                    null,
                    null,
                    null,
                ])}
            padding: 25px 10px;
            border-top: 2px solid ${COLORS.background.grayShade} !important;
            border-bottom: 2px solid ${COLORS.background.grayShade} !important;
            > .productWrapper:not(:first-child) {
                margin-top: 15px;
            }
        `,
    },
    productImageDetailsWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
        `,
    },
    qtyRow: {
        css: css`
            display: flex;
            flex-direction: row;
        `,
    },
    configSectionWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            padding: 3px 0px;
        `,
    },
    defaultText: {
        variant: "p",
    },
    quantityAdjustedText: {
        variant: "p",
    },
    configHeading: {
        variant: "p",
        color: "text.main",
        css: css`
            font-size: 12px;
            margin-top: 10px;
            font-weight: bold;
        `,
    },
    sectionName: {
        variant: "p",
        color: "text.base",
        css: css`
            font-weight: ${TYPOGRAPHY.weight.mediumbold};
            font-size: ${TYPOGRAPHY.size.smaller} !important;
            line-height: 16px;
            margin-right: 4px;
            margin-bottom: 12px;
            text-transform: uppercase;
        `,
    },
    optionName: {
        variant: "p",
        color: "text.main",
        css: css`
            font-size: ${TYPOGRAPHY.size.smaller} !important;
            line-height: 16px;
        `,
    },
    imgStyle: {
        css: css`
            padding: 0px;
            img {
                height: 64px;
                width: 64px;
            }
        `,
    },
    routerLink: {
        typographyProps: {
            variant: "p",
            css: css`
                font-weight: 400;
            `,
        },
        color: "secondary",
    },
    requireDrawingApproval: {
        css: css`
            font-weight: 600;
            font-size: 14px;
            line-height: 16px;
            color: #3ca865;
            margin-left: 2px;
        `,
    },
    requireDrawingApprovalWrapper: {
        css: css`
            flex: 1 1 auto;
            max-width: 394px !important;
            width: 100% !important;
            display: flex;
            flex-direction: row;
            color: #3ca865;
            padding-top: 16px;
        `,
    },
    drawwingApprovalIcon: {
        size: 12,
        css: css`
            > svg {
                > path {
                    fill: #3ca865;
                }
            }
        `,
    },
};

const mapStateToProps = (state: ApplicationState) => ({
    cartUrl: getPageLinkByPageType(state, "CartPage")?.url,
    orderSubTotalDisplay: getCurrentCartState(state).value?.orderSubTotalDisplay,
    cart: getCurrentCartState(state).value,
});

type Props = OwnProps & HasHistory & ReturnType<typeof mapStateToProps>;
const styles = productAddedToCartMessageStyles;

const ProductAddedToCartMessage = ({
    isQtyAdjusted,
    multipleProducts,
    cartLines,
    cartUrl,
    orderSubTotalDisplay,
    history,
    cart,
    brandName,
    toasterDisplayVal,
    onToastDismiss,
}: Props) => {
    const toasterContext = useContext(ToasterContext);
    const toastRef = useRef<HTMLDivElement | null>(null);
    const dismissReasonRef = useRef<"viewCart" | "other">("other");
    const formatDiscountPercent = (value?: string | number): string | null => {
        if (value === undefined || value === null) {
            return null;
        }
        const num = Number(value);
        if (Number.isNaN(num)) {
            return null;
        }
        const rounded = Math.round(num * 10) / 10;
        return rounded.toString();
    };

    useEffect(() => {
        return () => {
            toasterContext.removeToast(toasterDisplayVal[0]);
        };
    }, []);
    useEffect(() => {
        const handleOutsideClick = (event: MouseEvent) => {
            if (toastRef.current && !toastRef.current.contains(event.target as Node)) {
                toasterContext.removeToast(toasterDisplayVal[0]);
            }
        };

        document.addEventListener("mousedown", handleOutsideClick);

        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);
    useEffect(() => {
        return () => {
            if (dismissReasonRef.current !== "viewCart") {
                onToastDismiss?.();
            }
        };
    }, []);

    const defaultMessage = multipleProducts
        ? siteMessage("Cart_AllProductsAddedToCart")
        : siteMessage("Cart_ProductAddedToCart");

    if (!cartLines) {
        return <Typography {...styles.defaultText}>{defaultMessage}</Typography>;
    }
    function IsJsonString(msg: string) {
        try {
            return JSON.parse(msg);
        } catch (error) {
            return msg;
        }
    }

    const message: any = !cart?.cartNotPriced && cart?.messages?.map(item => IsJsonString(item));

    let brandOrderMinimumList = message?.filter((msg: any) => {
        if (msg.BrandOrderMinimumList !== undefined) {
            return msg.BrandOrderMinimumList;
        }
    });

    if (brandOrderMinimumList.length !== 0) {
        brandOrderMinimumList = brandOrderMinimumList[0].BrandOrderMinimumList;
    } else {
        brandOrderMinimumList = undefined;
    }

    const closeToster = () => {
        toasterContext.removeToast(toasterDisplayVal[0]);
    };
    const formatTimeWithBusinessZone = (dateString: string) => {
        const date = new Date(dateString);

        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        const time = date.toLocaleTimeString(undefined, {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        });

        const offsetMinutes = -date.getTimezoneOffset();

        if (userTimeZone === "Asia/Kolkata" || offsetMinutes === 330) {
            return `${time} IST`;
        }

        const zone = date
            .toLocaleTimeString(undefined, {
                timeZoneName: "short",
            })
            .split(" ")
            .pop();

        return `${time} ${zone}`;
    };

    const promoDetails: PromoDetail[] = (() => {
        if (!cartLines || cartLines.length === 0) {
            return [];
        }

        const promos: PromoDetail[] = [];

        cartLines.forEach(line => {
            const promoDetailsRaw = line?.properties?.promoDetails;

            if (typeof promoDetailsRaw === "string") {
                try {
                    const parsed = JSON.parse(promoDetailsRaw);

                    if (Array.isArray(parsed)) {
                        parsed.forEach(item => {
                            if (item?.description) {
                                promos.push({
                                    description: item.description,
                                    startDate: item.startDate,
                                    endDate: item.endDate,
                                });
                            }
                        });
                    }
                } catch (e) {
                    // silently ignore bad promo JSON
                }
            }
        });

        return promos;
    })();

    return (
        <StyledWrapper ref={toastRef} {...styles.messageWrapper}>
            <StyledWrapper {...styles.iconTextWrapper}>
                <Icon src={RightArrowIcon} {...styles.iconStyle} />
                <Typography {...styles.headerText}>{translate("Added To Cart!")}</Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.productListWrapper}>
                {cartLines &&
                    cartLines.map(
                        cartline =>
                            cartline && (
                                <StyledWrapper
                                    key={cartline.erpNumber}
                                    {...styles.productWrapper}
                                    className="productWrapper"
                                >
                                    {brandOrderMinimumList &&
                                        cart?.canCheckOut === false &&
                                        !cart?.cartNotPriced &&
                                        brandOrderMinimumList?.map((item: any, index: number) => {
                                            if (item.BrandName === brandName) {
                                                return (
                                                    <StyledWrapper {...styles.orderMinStyles} key={index}>
                                                        <Icon src={CustomAlertIcon} />
                                                        <Typography as="p" {...styles.orderMinMsgStyles}>
                                                            {siteMessage(
                                                                "OrderMinimumMsg",
                                                                `${item.BrandName}`,
                                                                `${item.OrderMinimumTotal}`,
                                                                `<a href='/brands/${item.BrandName}' target="_blank">Shop By ${item.BrandName}</a>`,
                                                            )}
                                                        </Typography>
                                                    </StyledWrapper>
                                                );
                                            }
                                            return null;
                                        })}
                                    <StyledWrapper {...styles.productImageDetailsWrapper}>
                                        <StyledWrapper {...styles.productImageWrap}>
                                            <LazyImage
                                                {...styles.imgStyle}
                                                src={cartline.smallImagePath}
                                                altText={cartline.altText}
                                            />
                                        </StyledWrapper>
                                        <StyledWrapper {...styles.productPriceWrapper}>
                                            <Typography {...styles.productNum}>{cartline.shortDescription}</Typography>
                                            <Typography as="p" {...styles.mpnNumber}>
                                                <Typography>
                                                    {translate("MPN")}:&nbsp;{cartline.manufacturerItem}
                                                </Typography>
                                            </Typography>
                                            <StyledWrapper {...styles.qtyRow}>
                                                <Typography {...styles.sectionName}>
                                                    {translate("Qty")}:&nbsp;
                                                </Typography>
                                                <Typography {...styles.optionName}>{cartline.qtyOrdered}</Typography>
                                            </StyledWrapper>
                                            <Typography {...styles.productPrice}>
                                                <Typography {...styles.productTotal}>
                                                    {translate("Total")}:&nbsp;{cartline.pricing?.actualPriceDisplay}
                                                </Typography>
                                            </Typography>
                                        </StyledWrapper>
                                    </StyledWrapper>
                                    {cart?.cartLines?.map((getProp: any) => {
                                        if (
                                            getProp.properties.requiredDrawingApproval === "true" &&
                                            getProp.productId === cartline.productId
                                        ) {
                                            return (
                                                <GridItem {...styles.requireDrawingApprovalWrapper}>
                                                    <Icon src={CustomInfoIcon} {...styles.drawwingApprovalIcon}></Icon>
                                                    <Typography {...styles.requireDrawingApproval}>
                                                        {siteMessage("requiredDrawingApprovalToaster")}{" "}
                                                    </Typography>
                                                </GridItem>
                                            );
                                        }
                                    })}
                                    <StyledWrapper>
                                        <Typography>{cartline.properties.specialMessage}</Typography>
                                        <Typography>{cartline.properties.alertMessage}</Typography>
                                    </StyledWrapper>
                                    {cartline.sectionOptions && cartline.sectionOptions.length !== 0 && (
                                        <StyledWrapper>
                                            <Typography {...styles.configHeading}>
                                                {translate("CONFIGURATION")}
                                            </Typography>
                                            {cartline.sectionOptions.map(sectionOption => (
                                                <StyledWrapper
                                                    {...styles.configSectionWrapper}
                                                    key={sectionOption.sectionOptionId}
                                                >
                                                    <Typography {...styles.sectionName}>
                                                        {`${sectionOption.sectionName}:`}&nbsp;
                                                    </Typography>
                                                    <Typography {...styles.optionName}>
                                                        {sectionOption.optionName}
                                                    </Typography>
                                                </StyledWrapper>
                                            ))}
                                        </StyledWrapper>
                                    )}
                                </StyledWrapper>
                            ),
                    )}
            </StyledWrapper>
            <StyledWrapper>
                {promoDetails.map((promo, index) => (
                    <StyledWrapper
                        key={index}
                        {...styles.promoMsgModalWrapper}
                        style={{ marginTop: index > 0 ? "4px" : "0" }}
                    >
                        <StyledWrapper {...styles.promoMsgWrapper}>
                            <Icon {...styles.promoRightTickIcon} src={Check} />
                            <StyledWrapper>
                                <StyledWrapper {...styles.promoMsgLinePartOne}>
                                    {siteMessage("promoToasterDiscountText", `${promo.description}`)}
                                </StyledWrapper>

                                {promo.endDate && (
                                    <StyledWrapper {...styles.promoMsgLineTwo}>
                                        {siteMessage(
                                            "promoValidTillMessage",
                                            formatTimeWithBusinessZone(promo.endDate),
                                        )}
                                    </StyledWrapper>
                                )}
                            </StyledWrapper>
                        </StyledWrapper>
                    </StyledWrapper>
                ))}

                <Typography {...styles.productPrice}>
                    <Typography {...styles.cartTotal}>
                        {translate("Cart Total")}&nbsp;{orderSubTotalDisplay}
                    </Typography>
                </Typography>

                <StyledWrapper {...styles.btnContainerStyles}>
                    <Link
                        href={cartUrl}
                        {...styles.viewCartBtnStyles}
                        target="_parent"
                        onClick={() => {
                            dismissReasonRef.current = "viewCart";
                            toasterContext.removeToast(toasterDisplayVal[0]);
                        }}
                    >
                        {translate("View Cart")}
                    </Link>
                    <Link href="#" {...styles.continueBtnStyles} onClick={closeToster} type="button">
                        {translate("Continue Shopping")}
                    </Link>
                </StyledWrapper>
            </StyledWrapper>

            {isQtyAdjusted && (
                <Typography {...styles.quantityAdjustedText}>{siteMessage("Cart_QuantityAdjusted")}</Typography>
            )}
        </StyledWrapper>
    );
};

export default withHistory(connect(mapStateToProps)(ProductAddedToCartMessage));
